import React from 'react';

import { ScansTypesProps } from './ScansTypes.props';

import ScansTypesView from './ScansTypes.view';

const ScansTypesContainer = (props: ScansTypesProps) => {
  return <ScansTypesView />;
};

export default ScansTypesContainer;
